import { TRootState } from 'Redux/Reducers';

export const getSelectedOffer = (state: TRootState) => state.payment.selectedOffer;
